import axios from 'axios'

let baseUrl = 'https://backend.beammp.com'

if (process.env.NODE_ENV == "development") baseUrl = 'http://localhost:3600'

export const getURL = () => {
  return baseUrl
}

export const getData = (userId) => {
  return baseUrl + '/data/' + userId
}

export const login_forum = (username, password, cb) => {
  axios.post(baseUrl + '/login-forum', {
    username: username,
    password: password
  })
    .then(function (response) {
      //console.log(response);
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`
      cb(response.data)
    })
    .catch(function (error) {
      console.log('error', error);
      return cb(error)
    });
}

export const login_check = (token, cb) => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  axios.post(baseUrl + '/login-check')
    .then(function (response) {
      //console.log(response);
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`
      setTimeout(cb(response.data), 500)
    })
    .catch(function (error) {
      console.log('error', error);
      return cb(error)
    });
}

export const migrate_auth = (u, p, cb) => {
  axios.post(baseUrl + '/account-migrate', {username: u, password: p})
    .then(function (response) {
      //console.log(response);
      cb(null, response.data)
    })
    .catch(function (error) {
      console.log('error', error);
      return cb(error)
    });
}

export const get_server_version = (cb) => {
  axios.get(baseUrl + '/version/server', {})
    .then(function (response) {
      //console.log(response);
      cb(null, response.data)
    })
    .catch(function (error) {
      console.log('error', error);
      return cb(error)
    });
}

export const create_key = (name, cb) => {
  axios.post(baseUrl + '/api/createKey', {
    name: name,
  })
    .then(function (response) {
      //console.log(response);
      cb(response.data)
    })
    .catch(function (error) {
      console.log('error', error);
      return cb(error)
    });
}

export const rename_key = (name, key, cb) => {
  axios.post(baseUrl + '/api/renameKey', {
    name: name,
    key: key
  })
    .then(function (response) {
      //console.log(response);
      cb(response.data)
    })
    .catch(function (error) {
      console.log('error', error);
      return cb(error)
    });
}

export const get_keys = (cb) => {
  axios.post(baseUrl + '/api/getKeys')
    .then(function (response) {
      //console.log(response.data);
      cb(null, response.data)
    })
    .catch(function (error) {
      console.log('error', error);
      return cb(error)
    });
}

export const get_server = (key, cb) => {
  axios.post(baseUrl + '/api/getServer', {
    key: key
  })
    .then(function (response) {
      //console.log(response.data);
      cb(null, response.data)
    })
    .catch(function (error) {
      if (error.response.status == 400) {
        cb(null, [])
      } else {
        console.log('error', error);
        return cb(error)
      }
    });
}

export const get_key_owner = (key, cb) => {
  axios.post(baseUrl + '/api/getKeyOwner', {
    key: key
  })
    .then(function (response) {
      //console.log(response.data);
      cb(null, response.data)
    })
    .catch(function (error) {
      console.log('error', error);
      return cb(error)
    });
}

export const get_releases = (cb) => {
  axios.post(baseUrl + '/api/getReleases', {
    type: 'server'
  })
    .then(function (response) {
      //console.log(response.data);
      cb(null, response.data)
    })
    .catch(function (error) {
      console.log('error', error);
      cb(error)
    });
}